// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel {
    'transactionId'?: number;
    'startingDate'?: Moment;
    'numberDays'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel>> = [
        {
            "name":     "transactionId",
            "baseName": "transactionId",
            "type":     "number"
        },
        {
            "name":     "startingDate",
            "baseName": "startingDate",
            "type":     "Date"
        },
        {
            "name":     "numberDays",
            "baseName": "numberDays",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsRequestTypesBmsGetNextBusinessDaysRequestModel.attributeTypeMap;
    }
}
